import { getNavigationAutos } from "./getNavigationAutos";
import { getLocationsHistory } from "./getLocationsHistory";
import { resetLocationsHistory } from "./resetLocationsHistory";
import {
  getClientFuelEventsHistory,
  getClientParkingEventsHistory,
  getClientTollsEventsHistory,
} from "./getClientEventsHistory";
import { resetClientEventHistory } from "./resetClientEventHistory";
import { addClientEventHistoryFilter } from "./addClientEventHistoryFilter";
import { deleteClientEventHistoryFilter } from "./deleteClientEventHistoryFilter";
import { resetClientEventHistoryFilter } from "./resetClientEventHistoryFilter";

export const navigationOperations = {
  getNavigationAutos,
  getLocationsHistory,
  resetLocationsHistory,
  getClientFuelEventsHistory,
  getClientParkingEventsHistory,
  getClientTollsEventsHistory,
  resetClientEventHistory,
  addClientEventHistoryFilter,
  deleteClientEventHistoryFilter,
  resetClientEventHistoryFilter,
};
